import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "user_info" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-address-card" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "fas fa-exclamation-circle",
  style: {"color":"red"},
  title: "到達未確認"
}
const _hoisted_4 = {
  key: 1,
  class: "fas fa-check-circle",
  style: {"color":"green"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _createTextVNode(" 登録情報")
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "refFrmUserInfo",
              model: _ctx.frmUserInfo,
              rules: _ctx.rules,
              "label-width": "160px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "御社名（法人の場合）" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "ポストエクスプレス株式会社",
                      modelValue: _ctx.frmUserInfo.corporateName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frmUserInfo.corporateName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "郵便番号",
                  prop: "postalCode"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "370-0042",
                      modelValue: _ctx.frmUserInfo.postalCode,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.frmUserInfo.postalCode) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "住所",
                  prop: "address"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "群馬県高崎市貝沢町496-1",
                      modelValue: _ctx.frmUserInfo.address,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.frmUserInfo.address) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "電話番号",
                  prop: "tel"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "050-3851-1095",
                      modelValue: _ctx.frmUserInfo.tel,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.frmUserInfo.tel) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "業種",
                  prop: "business"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_cascader, {
                      modelValue: _ctx.frmUserInfo.business,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.frmUserInfo.business) = $event)),
                      options: _ctx.options,
                      props: { expandTrigger: 'hover' },
                      onChange: _ctx.handleChange
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "ご担当者名",
                  prop: "personCharge"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "群馬太郎",
                      modelValue: _ctx.frmUserInfo.personCharge,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.frmUserInfo.personCharge) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "メールアドレス",
                  prop: "mailAddress"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "user@example.com",
                      modelValue: _ctx.frmUserInfo.mailAddress,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.frmUserInfo.mailAddress) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.frmUserInfo.confFlg==0)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                      : _createCommentVNode("", true),
                    (_ctx.frmUserInfo.confFlg==1)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "パスワード",
                  prop: "password"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "8文字以上",
                      modelValue: _ctx.frmUserInfo.password,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.frmUserInfo.password) = $event)),
                      "show-password": "",
                      autocomplete: "off"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "パスワード（確認）",
                  prop: "checkPass"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "確認のため再入力してください。",
                      modelValue: _ctx.frmUserInfo.checkPass,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.frmUserInfo.checkPass) = $event)),
                      "show-password": "",
                      autocomplete: "off"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    (_ctx.message.err)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 0,
                          title: _ctx.message.msg,
                          type: "error"
                        }, null, 8, ["title"]))
                      : _createCommentVNode("", true),
                    (!_ctx.message.err && _ctx.message.msg)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 1,
                          title: _ctx.message.msg,
                          type: "success"
                        }, null, 8, ["title"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitForm('frmUserInfo')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("更新")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "info",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cancel()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("戻る")
                      ]),
                      _: 1
                    }),
                    (_ctx.frmUserInfo.mailAddress != '' && _ctx.frmUserInfo.confFlg==0)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "success",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.confmail()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("確認用メール送信")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}